import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import $ from 'jquery';
import jqueryBridget from 'jquery-bridget';
import Isotope from 'isotope-layout';
import 'isotope-packery';
jqueryBridget('isotope', Isotope, $);
console.log('block-gallery-bricks.js');
var BlockGalleryBricks = /*#__PURE__*/function () {
  function BlockGalleryBricks() {
    _classCallCheck(this, BlockGalleryBricks);
    this.selector = '.wp-block-gallery-bricks';
    this[typeof wp === 'undefined' ? 'init' : 'initEditor']();
  }
  _createClass(BlockGalleryBricks, [{
    key: "isotopeOptions",
    get: function get() {
      return {
        // layoutMode: 'packery',
      };
    }
  }, {
    key: "init",
    value: function init() {
      this.$els = $(this.selector);
      this.$els.find("".concat(this.selector, "__grid")).isotope(this.isotopeOptions);
    }
  }, {
    key: "initEditor",
    value: function initEditor() {
      var _this = this;
      if (!window.acf) return;
      window.acf.addAction('render_block_preview/type=gallery-bricks', function ($block) {
        $block.find("".concat(_this.selector, "__grid")).isotope(_this.isotopeOptions);
      });
    }
  }]);
  return BlockGalleryBricks;
}();
$(function () {
  new BlockGalleryBricks();
});